import Button from '@mui/material/Button';
import MuiDialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import MuiDialogTitle from '@mui/material/DialogTitle';
import is from '@sindresorhus/is';
import type { FunctionComponent, ReactElement } from 'react';
import { useContext } from 'react';
import { useSearchParams } from 'react-router';

import { ApplicationContext } from '~/shared/context/context';
import { useTermsQuery } from '~/shared/query-hooks/terms';

import { route } from './constants';

export const PrivacyTermsDialog: FunctionComponent = () => {
    const { translate } = useContext(ApplicationContext);
    const { termsQuery } = useTermsQuery();
    const [searchParams, setSearchParams] = useSearchParams();
    const openGDPRDialog = searchParams.get(route.searchParams.openPrivacyStatement) === 'true';

    const dismissDialog = (): void => {
        const search = new URLSearchParams(searchParams);
        search.delete(route.searchParams.openPrivacyStatement);
        setSearchParams(search, { replace: true });
    };

    // biome-ignore lint/suspicious/noExplicitAny: suppressed due to migration
    const getDialogContent = (): ReactElement<any> => {
        if (termsQuery.isError) {
            return <DialogContent>{translate('pages.settings.data-privacy.dialog.load-error')}</DialogContent>;
        }

        if (termsQuery.isPending) {
            return <DialogContent>{translate('pages.settings.data-privacy.dialog.loading')}</DialogContent>;
        }

        const termsText = is.nonEmptyStringAndNotWhitespace(termsQuery.data.text)
            ? termsQuery.data.text
            : termsQuery.data.shortText;

        return (
            <DialogContent>
                {/** biome-ignore lint/security/noDangerouslySetInnerHtml: suppressed due to migration */}
                <DialogContentText dangerouslySetInnerHTML={{ __html: termsText }} />
            </DialogContent>
        );
    };

    return (
        <MuiDialog maxWidth="md" open={openGDPRDialog} onClose={dismissDialog}>
            <MuiDialogTitle>{translate('pages.settings.data-privacy.dialog.title')}</MuiDialogTitle>
            {getDialogContent()}
            <DialogActions>
                <Button onClick={dismissDialog}>{translate('common.close')}</Button>
            </DialogActions>
        </MuiDialog>
    );
};
